<template>
  <div>
    <div class="text-right">
      <button
        class="mb-2 bg-green px-4 py-2 text-white shadow-md rounded-sm font-normal"
        @click="addNewSegment"
      >
        Create Segment (c)
      </button>
    </div>
    <div class="w-full h-full mt-3">
      <Table
        ref="segmentTable"
        :endpoint="endpoint"
        :tableConfig="tableConfig"
      />
      <div>
        <VModal
          name="segment-modal"
          :click-to-close="false"
          width="1100"
          height="700"
        >
          <SegmentBuilder
            @discard-change="hideSegmentModal"
            @segment-created="handleSegmentCreation"
          />
        </VModal>
      </div>
    </div>
  </div>
</template>

<script>
import Table from "@/components/DataTable/Table"
import siteConfig from "@/utils/siteConfig"
import SegmentBuilder from "@/components/Notification/SegmentBuilder"
import { duplicateSegment } from "@/apis/notification/index"

export default {
  components: {
    Table,
    SegmentBuilder,
  },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}notifications/segments`,
      notyConfig: {
        layout: "bottomLeft",
        animation: {
          open: "slideUp",
          close: "fadeOut",
        },
      },
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          classList: "w-1/3",
          path: "name",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Duplicate" },
          path: "id",
          type: "button",
          classList:
            "copy-button rounded-sm m-0 flex justify-center items-center hover:bg-grey-light focus:bg-grey-light",
          buttonText: `<svg xmlns="http://www.w3.org/2000/svg" height="20" fill="grey" viewBox="-40 0 512 512" width="20"><path d="m271 512h-191c-44.113281 0-80-35.886719-80-80v-271c0-44.113281 35.886719-80 80-80h191c44.113281 0 80 35.886719 80 80v271c0 44.113281-35.886719 80-80 80zm-191-391c-22.054688 0-40 17.945312-40 40v271c0 22.054688 17.945312 40 40 40h191c22.054688 0 40-17.945312 40-40v-271c0-22.054688-17.945312-40-40-40zm351 261v-302c0-44.113281-35.886719-80-80-80h-222c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h222c22.054688 0 40 17.945312 40 40v302c0 11.046875 8.953125 20 20 20s20-8.953125 20-20zm0 0"/></svg>`,
          onclick: id => {
            this.duplicateSegment(id)
          },
        },
        {
          header: { textContent: "Edit" },
          routePath: "/edit-segment/:id",
          type: "action",
          actionButtonText: "Edit",
          path: "id",
        },
      ],
    }
  },
  beforeDestroy() {
    document.removeEventListener("keypress", () => this.handleKeypress)
  },
  mounted() {
    document.addEventListener("keypress", e => this.handleKeypress(e))
  },
  methods: {
    handleKeypress(e) {
      if (
        e.target.nodeName !== "INPUT" &&
        e.target.nodeName !== "TEXTAREA" &&
        e.code === "KeyC"
      ) {
        this.addNewSegment()
      }
    },
    handleSegmentCreation() {
      this.hideSegmentModal()
      this.refreshTable()
    },
    duplicateSegment(id) {
      this.$noty.info("Creating a duplicate, please wait", this.notyConfig)
      duplicateSegment(id)
        .then(res => {
          this.$noty.info(
            `Duplicate segment created: ${res.data.name}`,
            this.notyConfig
          )
          this.refreshTable()
        })
        .catch(err => {
          console.error(err)
          this.$noty.error("Failed to duplicate segment", this.notyConfig)
        })
    },
    refreshTable() {
      this.$refs.segmentTable.getItems()
    },
    addNewSegment() {
      this.$modal.show("segment-modal")
    },
    hideSegmentModal() {
      this.$modal.hide("segment-modal")
    },
  },
}
</script>

<style>
.ed-table-wrapper .copy-button {
  width: 100%;
  height: 25px;
  padding: 0;
}
</style>
